import { Reducer } from "redux";

import { AirlinesAction, AirlinesActionTypes, AirlinesState } from "./types";

const initialState: AirlinesState = {
  count: 0,
  items: [],
  itemsByIata: {},
  isLoading: false,
};

const reducer: Reducer<AirlinesState, AirlinesAction> = (state = initialState, action) => {
  switch (action.type) {
    case AirlinesActionTypes.IATA_FETCH_REQUEST:
      return { ...state, isLoading: true };

    case AirlinesActionTypes.TABLE_FETCH_REQUEST: {
      return { ...state, itemsByIata: {}, isLoading: true };
    }

    case AirlinesActionTypes.IATA_FETCH_ERROR:
    case AirlinesActionTypes.TABLE_FETCH_ERROR:
      return { ...state, isLoading: false };

    case AirlinesActionTypes.TABLE_FETCH_SUCCESS: {
      const { count, results } = action.payload;
      return { ...state, count, isLoading: false, items: results };
    }

    case AirlinesActionTypes.IATA_FETCH_SUCCESS: {
      const { iata, items } = action.payload;
      return {
        ...state,
        isLoading: false,
        itemsByIata: { ...state.itemsByIata, [iata]: items },
      };
    }

    default:
      return state;
  }
};

export default reducer;
